import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import img1 from "../../assets/img/item/s1.png";
import img2 from "../../assets/img/item/s2.png";
import img3 from "../../assets/img/item/s3.png";
import img4 from "../../assets/img/item/s4.png";
import img5 from "../../assets/img/item/s5.png";
import img6 from "../../assets/img/item/s6.png";
import img7 from "../../assets/img/item/s7.png";
import img8 from "../../assets/img/item/s8.png";
import Chart from "../../components/Chart";
import ItemsActivityButtons from "../../components/ItemsActivityButtons";
import SelectCard from "../../components/SelectCard";
import {
	AngleDown,
	BinanceIcon,
	NextSlide,
	PrevSlide,
	Star,
} from "../../icon/IconTheme";
const Activity = () => {
	const sliderRef = useRef();
	const nextSlide = () => {
		sliderRef.current.slickNext();
	};
	const prevSlide = () => {
		sliderRef.current.slickPrev();
	};
	const settings = {
		dots: true,
		infinite: true,
		speed: 300,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		margin: 30,
	};

	const [mobileScreen, setMobileScreen] = useState(true);

	const handleMobile = () => {
		const width = window.innerWidth;
		if (width < 992) {
			setMobileScreen(true);
		} else {
			setMobileScreen(false);
		}
	};

	useEffect(() => {
		handleMobile();
		window.addEventListener("resize", handleMobile);
	}, []);
	const [dropdownOpen, setDropdownOpen] = useState(false);

	return (
		<>
			<h4 className="section-title">Energy Center</h4>
			<div className="filter-top-bar">
				<ItemsActivityButtons mainSize />
				<div className="summary-select ms-auto">
					<SelectCard data={data} />
				</div>
			</div>
			<div className="__chart-container">
				<div className="chart-wrapper-2">
					{mobileScreen ? (
						<>
							<Slider {...settings} ref={sliderRef}>
								{["", ""].map((item, i) => (
									<div className="chart-item" key={i}>
										<Chart />
									</div>
								))}
							</Slider>
							<div className="nav-btns">
								<div onClick={prevSlide}>
									<PrevSlide />
								</div>
								<div onClick={nextSlide}>
									<NextSlide />
								</div>
							</div>
						</>
					) : (
						["", ""].map((item, i) => (
							<div className="chart-item" key={i}>
								<Chart />
							</div>
						))
					)}
				</div>
			</div>
			<div className="chart-wrapper">
				<h3 className="title">
					<div className="position-relative d-inline-block">
						<Link to="#" className="text-white">
							Item Sold <AngleDown />
						</Link>
						<ul
							className={`__dropdown-menu dropdown-menu ${
								dropdownOpen ? "active" : ""
							}`}
							onClick={() => setDropdownOpen(false)}
							onMouseDown={() => setDropdownOpen(true)}
						>
							<li>
								<Link className="dropdown-item" to="#0">
									Hash Score
								</Link>
							</li>
							<li>
								<Link className="dropdown-item" to="#0">
									Minting
								</Link>
							</li>
						</ul>
					</div>
				</h3>
				{data2 && (
					<table className="table m-0 __table">
						<thead>
							<tr>
								<th>Name</th>
								<th>Price</th>
								<th>Seller</th>
								<th>Buyer</th>
								<th>Date</th>
							</tr>
						</thead>
						<tbody>
							{data2.map(({ img, title }, i) => (
								<tr key={i}>
									<td>
										<div className="table-item">
											<img src={img} alt="" />
											<div className="info">
												<h6>{title}</h6>
												<div className="rating">
													<Star />
													<Star />
													<Star />
													<Star />
												</div>
												<span>
													Hash Score: <span>12354657886</span>
												</span>
											</div>
										</div>
									</td>
									<td>
										<div className="mobile-info price">
											<div className="subtext">Seller</div>
											<div className="d-flex align-items-center">
												<BinanceIcon /> 0.05
												<span className="text-body">($13.26)</span>
											</div>
										</div>
									</td>
									<td>
										<div className="mobile-info">
											<div className="subtext">Seller</div>
											<h6>fgdTWT4532</h6>
										</div>
									</td>
									<td>
										<div className="mobile-info">
											<div className="subtext">Buyer</div>
											<h6>fgdTWT4532</h6>
										</div>
									</td>
									<td>
										<div className="mobile-info">
											<div className="subtext">Date</div>
											<h6>12/22/2022</h6>
										</div>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				)}
			</div>
		</>
	);
};

const data = [
	{
		option: "Summary",
		value: "1",
	},
	{
		option: "Last Month",
		value: "1",
	},
	{
		option: "Last Year",
		value: "1",
	},
	{
		option: "Archived",
		value: "1",
	},
];

const data2 = [
	{
		title: "Hashima 1",
		img: img1,
	},
	{
		title: "Hashima 1",
		img: img2,
	},
	{
		title: "Hashima 1",
		img: img3,
	},
	{
		title: "Hashima 1",
		img: img4,
	},
	{
		title: "Hashima 1",
		img: img5,
	},
	{
		title: "Hashima 1",
		img: img6,
	},
	{
		title: "Hashima 1",
		img: img7,
	},
	{
		title: "Hashima 1",
		img: img8,
	},
];
export default Activity;
